"use client";

import { c as _c } from "react/compiler-runtime";
import { Clipboard, Check } from "lucide-react";
import React, { useState } from "react";
import { cn } from "@/src/lib/shadcn-utils";
export const COPIED_RESET_DELAY_MS = 1500;
interface CopyableContentProps {
  text: string;
  upperCase?: boolean;
  textClassName?: string;
  iconOnly?: boolean;
  alwaysShow?: boolean;
  className?: string;
  children?: React.ReactNode;
}
export function CopyableContent(t0) {
  const $ = _c(18);
  const {
    text,
    upperCase,
    textClassName,
    alwaysShow,
    className,
    children
  } = t0;
  const [justCopied, setJustCopied] = useState(false);
  let t1;
  if ($[0] !== text || $[1] !== upperCase) {
    t1 = upperCase ? text.toUpperCase() : text;
    $[0] = text;
    $[1] = upperCase;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedText = t1;
  let t2;
  if ($[3] !== formattedText) {
    t2 = async function handleCopy() {
      try {
        await navigator.clipboard.writeText(formattedText);
        setJustCopied(true);
        setTimeout(() => setJustCopied(false), COPIED_RESET_DELAY_MS);
      } catch {}
    };
    $[3] = formattedText;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCopy = t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("relative group cursor-default py-0.5 text-foreground text-sm", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `group-hover:opacity-70 transition-opacity duration-200 group-active:opacity-40 ${textClassName}`;
  const t5 = children ?? formattedText;
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== alwaysShow || $[11] !== justCopied) {
    t7 = justCopied ? <Check size={14} className="ml-1 text-green-600 transition-colors group-hover:opacity-100 inline" /> : <Clipboard size={14} className={`ml-1 text-muted-foreground ${alwaysShow ? "opacity-50" : "opacity-0"} group-hover:opacity-100 transition-opacity inline relative top-[-1px]`} />;
    $[10] = alwaysShow;
    $[11] = justCopied;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== handleCopy || $[14] !== t3 || $[15] !== t6 || $[16] !== t7) {
    t8 = <span className={t3} onClick={handleCopy}>{t6}{t7}</span>;
    $[13] = handleCopy;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
export function CopyIcon(t0) {
  const $ = _c(7);
  const {
    text
  } = t0;
  const [justCopied, setJustCopied] = useState(false);
  const formattedText = text;
  let t1;
  if ($[0] !== formattedText) {
    t1 = async function handleCopy() {
      if (!formattedText) {
        return;
      }
      try {
        await navigator.clipboard.writeText(formattedText);
        setJustCopied(true);
        setTimeout(() => setJustCopied(false), COPIED_RESET_DELAY_MS);
      } catch {}
    };
    $[0] = formattedText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  if ($[2] !== justCopied) {
    t2 = justCopied ? <Check size={14} className="ml-1 text-green-600 transition-colors group-hover:opacity-100 inline" /> : <Clipboard size={14} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity inline relative top-[-1px]" />;
    $[2] = justCopied;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleCopy || $[5] !== t2) {
    t3 = <span className="relative group cursor-default" onClick={handleCopy}>{t2}</span>;
    $[4] = handleCopy;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}